export const SET_MQTT_CONNECTION = 'MQTT/Connection/set';
